import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  download(event) {
    const formatOption = document.querySelector('input[name="exportFormat"]:checked')
    const versionOption = document.querySelector('input[name="exportVersion"]:checked')

    const link = event.currentTarget
    const baseUrl = link.href.split('?')[0]

    // Build query params
    const params = new URLSearchParams()

    if (versionOption && versionOption.value === 'all') {
      params.set('all_versions', 'true')
    }

    if (formatOption && formatOption.value === 'individual') {
      params.set('format', 'individual')
    }

    // Update href
    const queryString = params.toString()
    link.href = queryString ? `${baseUrl}?${queryString}` : baseUrl

    // Close modal after download starts
    setTimeout(() => {
      const modalElement = document.getElementById('auditExportModal')
      if (!modalElement) return

      // Try Bootstrap Modal instance first
      if (window.bootstrap && window.bootstrap.Modal) {
        const modal = window.bootstrap.Modal.getInstance(modalElement)
        if (modal) {
          modal.hide()
          return
        }
      }

      // Fallback: click close button
      const closeButton = modalElement.querySelector('[data-bs-dismiss="modal"]')
      if (closeButton) closeButton.click()
    }, 150)
  }
}
